import { render, staticRenderFns } from "./ui-date-picker.vue?vue&type=template&id=a0d0296e&"
import script from "./ui-date-picker.vue?vue&type=script&lang=ts&"
export * from "./ui-date-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports